<template>
    <div>
        <!-- step 1 -->
        <ForgotPasswordEmailDialog />

        <!-- step 2 -->
        <ForgotPasswordVerificationLinkSentDialog />

        <!-- step 3 -->
        <ForgotPasswordNewPasswordDialog />

        <!-- step 4 -->
        <ForgotPasswordAllDoneDialog />
    </div>
</template>



<script setup lang="ts">

import ForgotPasswordEmailDialog from "@/components/Auth/ForgotPassword/Dialogs/Forgot-Password-Email-Dialog.vue";
import ForgotPasswordAllDoneDialog from "@/components/Auth/ForgotPassword/Dialogs/Forgot-Password-All-Done-Dialog.vue";
import ForgotPasswordNewPasswordDialog from "@/components/Auth/ForgotPassword/Dialogs/Forgot-Password-New-Password-Dialog.vue";
import ForgotPasswordVerificationLinkSentDialog from "@/components/Auth/ForgotPassword/Dialogs/Forgot-Password-Verification-Link-Sent.vue";

</script>